import { Trans } from '@lingui/react/macro';
import { Link } from 'react-router-dom';

/**
 * The OCIF API (api/ocif/v1) loads data and uploads files, but has no endpoint to mark a schedule
 * as done or submit the report, so those steps always happen in the app.
 */
export function ApiFilingNote() {
  return (
    <>
      <strong>API:</strong>{' '}
      <Trans>
        integrate from your core system with the OCIF API. Generate an API key from <Link to="/profile">My Profile</Link> (only shown if your user has
        API access). The API can load data and upload files; marking schedules as done and submitting for review are still done on this page.
      </Trans>
    </>
  );
}
